import { useEffect, useState } from 'react';
import { CircleCheckBig, KeyRound } from 'lucide-react';
import { Button } from '../ui';
import {
  isPasskeyCancel, isPasskeySupported, listPasskeys, passkeyErrorMessage, registerPasskey
} from '../../services/passkeyService';
import styles from './Onboarding.module.css';

/** Passkey direkt aus dem Hinweis heraus einrichten */
function PasskeyAction() {
  const supported = isPasskeySupported();
  const [status, setStatus] = useState('idle'); // idle | busy | done | exists
  const [error, setError] = useState('');

  useEffect(() => {
    if (!supported) return;
    let cancelled = false;
    listPasskeys()
      .then((list) => { if (!cancelled && list.length > 0) setStatus((s) => (s === 'idle' ? 'exists' : s)); })
      .catch(() => { /* Anzeige ohne Vorabprüfung */ });
    return () => { cancelled = true; };
  }, [supported]);

  if (!supported) {
    return (
      <p className={styles.actionNote}>
        Auf diesem Gerät bzw. in diesem Browser ist das gerade nicht möglich – du kannst den Passkey später auf einem anderen Gerät unter Einstellungen einrichten.
      </p>
    );
  }

  if (status === 'done' || status === 'exists') {
    return (
      <p className={styles.actionSuccess} role="status">
        <CircleCheckBig aria-hidden />
        {status === 'done' ? 'Passkey eingerichtet – beim nächsten Mal „Mit Passkey anmelden“ wählen.' : 'Du hast bereits einen Passkey eingerichtet.'}
      </p>
    );
  }

  const add = async () => {
    setError('');
    setStatus('busy');
    try {
      await registerPasskey();
      setStatus('done');
    } catch (err) {
      setStatus('idle');
      if (!isPasskeyCancel(err)) setError(passkeyErrorMessage(err));
    }
  };

  return (
    <div className={styles.action}>
      <Button variant="secondary" icon={KeyRound} onClick={add} loading={status === 'busy'}>
        Passkey jetzt einrichten
      </Button>
      {error && <p className={styles.actionError} role="alert">{error}</p>}
    </div>
  );
}

export default function OnboardingAction({ action }) {
  if (action === 'passkey') return <PasskeyAction />;
  return null;
}
